/*
 * Gets Google Maps link for a given location
 */
function useMapLink(location) {
  if (!location) return '';

  // Finiteness, not truthiness: latitude 0 is a real coordinate and used to
  // fall through to the place_id / address branch.
  if (Number.isFinite(location.latitude) && Number.isFinite(location.longitude)) {
    if (location.google_place_id) {
      return `https://www.google.com/maps/search/?api=1&query=${location.latitude},${location.longitude}&query_place_id=${location.google_place_id}`;
    } else {
      return `https://www.google.com/maps/search/?api=1&query=${location.latitude},${location.longitude}`;
    }
  }

  if (location.google_place_id) {
    return `https://www.google.com/maps/place/?q=place_id:${location.google_place_id}`;
  }

  if (location.address) {
    return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(location.address)}`;
  }

  return '';
}

export default useMapLink;
